// extracted by mini-css-extract-plugin
export var locationCard = "_ew-0";